import styled from "styled-components";

export const MetaSeparator = styled.span`
    padding: 0 var(--space-sm);
    &:after {
        content: "·";
    }
`;
